export const REDUCER_NAME = 'appListSlice';

/**
 * App List DTO (row coming from backend)
 */
export interface iAppListDTO {
  vendorId: string;
  domainName: string;
  appName: string;
  gmail: string;
  appType: string;
  count: number;
  purchase: number;
}

/**
 * Redux State
 */
export interface iAppListState {
  appList: iAppListDTO[] | null;
  isLoading: boolean;
  errorMessage: string | null;
}
